import type { ReactNode } from "react";
import { Stack } from "@mui/material";
import { Connection } from "./Connection";
import { AddConnection } from "./AddConnection";
import { OptimisticConnection } from "./OptimisticConnection";
import { RemoveConnectionButton } from "./RemoveConnectionButton";
import { ConnectionsEmptyState } from "./ConnectionsEmptyState";

export const Connections = ({ children }: { children: ReactNode }) => (
  <Stack sx={{ gap: 0.5, mt: 1 }}>{children}</Stack>
);

Connections.Add = AddConnection;
Connections.Item = Connection;
Connections.OptimisticItem = OptimisticConnection;
Connections.RemoveButton = RemoveConnectionButton;
Connections.EmptyState = ConnectionsEmptyState;
